





































import { getCvsTypeLabel } from '@/models/purhase/cvs_type'
import { formatPrice } from '@/util/format'
import { OrderStatusViewModel } from '@spa/components/organisms/mypage/order/model/order-status-view'
import { CvsPaymentMethod, Order } from '@spa/store/modules/orderHistory/types'
import dateFormat from 'date-fns/format'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

interface CvsPaymentDetail {
  readonly shopName: string
  readonly authNumberLabel: string
  readonly expireDateLabel: string
  readonly amountLabel: string
}

@Component
/**
 * コンビニ決済時の配送状態を表示するコンポーネント
 * @see https://github.com/my-color/front/issues/7254
 */
export default class CvsStatusView extends Vue {
  @Prop({ required: true })
  readonly order: Order & {
    payment: {
      method: CvsPaymentMethod
    }
  }

  @Prop({ required: true })
  readonly statusView: OrderStatusViewModel

  get cvsPaymentDetail(): CvsPaymentDetail {
    return {
      shopName: getCvsTypeLabel(this.order.payment.method.cvs_type),
      authNumberLabel: this.order.paymentProviderAuthNumber,
      expireDateLabel: dateFormat(this.order.paymentProviderExpireDate, 'YYYY年MM月DD日'),
      amountLabel: formatPrice(this.order.chargeSheet.total),
    }
  }

  get isFamilyMart(): boolean {
    return this.order.payment.method.cvs_type === 'familymart'
  }
}
